// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__20sz0","span":"Navbar_span__32nTC","button":"Navbar_button__3vzks","logo":"Navbar_logo__21NHJ","menu":"Navbar_menu__3jPrU","a":"Navbar_a__HJcOO"};